import { filter, find } from 'lodash';
function hook() {
    const hooks = [];
    const f = function (opts) {
        for (let fn of hooks) {
            opts = fn(opts);
        }
        return opts;
    };
    f.add = function (fn) {
        hooks.push(fn);
        return fn;
    };
    return f;
}
;
const errorModalOptionsHook = hook();
const REGISTRY = [];
function onDomNodePrebuild(tagName, fn) {
    REGISTRY.push({ tagName, callback: fn });
}
function domNodePrebuild(context) {
    for (const { callback } of filter(REGISTRY, { tagName: context.spec.tagName })) {
        callback(context);
    }
}
function getOnComponentBuildHook(tagName) {
    const item = find(REGISTRY, { tagName });
    return item ? item.callback : null;
}
export const hooks = {
    onDomNodePrebuild,
    domNodePrebuild,
    errorModalOptionsHook
};
//# sourceMappingURL=hooks.js.map